import { reactive, ref } from 'vue'
import { getSiteConfig, getHotDomains, getHotPackages, getFriendlinks } from '../api/index.js'

function ensureHttps(url) {
  if (!url) return ''
  return url.replace(/^http:/, 'https:')
}

// ========== 站点配置 — /api/site/config ==========

export const siteConfig = reactive({
  title: '土云数据丨免费二级域名分发平台',
  sitename: '土云数据',
  description: '依托腾讯云、阿里云等顶级DNS服务商，提供极速解析、公益免费的二级域名分发服务，支持一键部署、SSL自动绑定，数据加密存储，助力新手开发者零成本体验企业级管理，快速落地创意。',
  keywords: '腾讯云,土云,土云数据,阿里云,华为云,百度智能云,二级域名分发,二级域,免费二级域,二级域名分发系统',
  version: '4.1.0',
  logo: '',
  ico: '',
})

// ========== 联系信息 — /api/site/config ==========

export const contactInfo = reactive({
  qq: '',
  qun: '',
  icp: '',
  admin: '派小星',
  operator: '',
  policeReg: '',
  kefulink: '',
})

// ========== 热门域名 — /api/site/domains ==========

export const hotDomains = ref([])

// ========== 套餐/定价 — /api/site/hotPackages ==========

export const packages = ref([])

// ========== 统计数据 ==========

export const stats = reactive({
  currentTime: new Date().toISOString().slice(0, 19).replace('T', ' '),
})

// ========== 友情链接 — /api/site/friendlinks ==========

export const friendLinks = ref([])

// ========== 核心优势卡片 — 静态 ==========

export const features = [
  { id: '01', title: '资源丰富', description: '汇聚海量优质二级域名，覆盖个人、企业等多场景，精准匹配各类业务需求。', accent: '#00e5ff', footer: 'DOMAINS: 100+', icon: 'database' },
  { id: '02', title: '高速解析', description: '依托全球边缘网络，实现毫秒级 DNS 响应，助力网站与应用快速稳定上线。', accent: '#944bda', footer: 'RESPONSE < 30ms', icon: 'bolt' },
  { id: '03', title: '灵活管理', description: '可视化后台支持解析记录一键增删改查，操作简单高效，无需专业技术背景。', accent: '#e4467d', footer: 'OP SPEED: 1-CLICK', icon: 'gear' },
]

// ========== 系统注入配置（PHP 框架在输出 HTML 前写入） ==========

function loadFromGlobalConfig() {
  const cfg = window.__SITE_CONFIG__
  if (!cfg) return false

  siteConfig.title       = cfg.title || siteConfig.title
  siteConfig.sitename    = cfg.short_name || cfg.title || siteConfig.sitename
  siteConfig.description = cfg.description || siteConfig.description
  siteConfig.keywords    = cfg.keywords || siteConfig.keywords
  siteConfig.version     = cfg.version || siteConfig.version
  siteConfig.logo        = ensureHttps(cfg.logo || '')
  siteConfig.ico         = ensureHttps(cfg.favicon || '')

  contactInfo.qq        = cfg.qq || ''
  contactInfo.qun       = cfg.qq_group_link || ''
  contactInfo.icp       = cfg.icp || ''
  contactInfo.admin     = cfg.copyright || ''
  contactInfo.operator  = cfg.operator || ''
  contactInfo.policeReg = cfg.ga_number || ''
  contactInfo.kefulink  = cfg.kefulink || ''

  return true
}

// ========== 数据初始化 ==========

export async function initSiteData() {
  // 优先使用系统注入的全局配置（PHP 框架在服务端已填充）
  const hasGlobal = loadFromGlobalConfig()

  try {
    // 没有全局配置时才调 API（本地开发 / 退档）
    if (!hasGlobal) {
      const config = await getSiteConfig()
      if (config) {
      siteConfig.title       = config.title || siteConfig.title
      siteConfig.sitename    = config.short_name || config.title || siteConfig.sitename
      siteConfig.description = config.description || siteConfig.description
      siteConfig.keywords    = config.keywords || ''
      siteConfig.version     = config.version || siteConfig.version
      siteConfig.logo        = ensureHttps(config.logo || '')
      siteConfig.ico         = ensureHttps(config.favicon || '')

      contactInfo.qq        = config.qq || ''
      contactInfo.qun       = config.qq_group_link || ''
      contactInfo.icp       = config.icp || ''
      contactInfo.admin     = config.copyright || ''
      contactInfo.operator  = config.operator || ''
      contactInfo.policeReg = config.ga_number || ''
      contactInfo.kefulink  = config.kefulink || ''
      }
    }

    // 域名列表
    const domains = await getHotDomains()
    if (domains && Array.isArray(domains)) {
      hotDomains.value = domains.map(d => ({
        id: d.id,
        url: d.url,
        buy_count: d.buy_count || 0,
      }))
    }

    // 热门套餐
    const pkgs = await getHotPackages()
    if (pkgs && Array.isArray(pkgs)) {
      packages.value = pkgs.map(p => ({
        id: p.id,
        name: p.name,
        url_name: p.url_name,
        parse_count: p.parse_count,
        price: p.price,
      }))
    }

    // 友情链接
    const links = await getFriendlinks()
    if (links && Array.isArray(links)) {
      friendLinks.value = links.map(l => ({
        id: l.id,
        name: l.name,
        url: l.url,
        image: l.image || '',
      }))
    }
  } catch (err) {
    console.error('[API] 数据加载失败，使用默认值:', err)
  }
}
